module.exports = __webpack_public_path__ + "img/insurance.c677476.png";